import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-200/80 bg-white/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/trc-logo.jpg" alt="The River Company" className="h-12 w-auto -my-1" />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600 font-medium">
          <a href="#how-it-works" className="hover:text-[#312D44] transition-colors">How it works</a>
          <a href="#categories" className="hover:text-[#312D44] transition-colors">What we measure</a>
          <Link to="/admin" data-testid="nav-admin" className="hover:text-[#312D44] transition-colors">Admin</Link>
        </nav>
        <Button
          onClick={() => navigate("/assessment")}
          data-testid="nav-start-assessment-btn"
          className="bg-[#312D44] hover:bg-[#1F1B30] text-white rounded-md text-sm font-medium px-4 py-2 h-9"
        >
          Start Assessment
        </Button>
      </div>
    </header>
  );
};

export default Navbar;
